<template>
    <div>
        <div class="content-header">
            <ol class="breadcrumb">
                <li class="active">参数配置</li>
            </ol>
        </div>
        <hr />
        <div class="title">
            <span>参数列表</span>
        </div>
        <div class="content-data" v-if="valueConfigs && 0 < valueConfigs.length">
            <el-table highlight-current-row :data="valueConfigs" border>
                <el-table-column align="center" type="index"></el-table-column>
                <el-table-column align="center" label="编码">
                    <template slot-scope="scope">
                        <span>{{scope.row.id}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="参数名">
                    <template slot-scope="scope">
                        <span>{{scope.row.remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="参数值">
                    <template slot-scope="scope">
                        <span>{{scope.row.value}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" fixed="right" label="操作">
                    <template slot-scope="scope">
                        <router-link :to="{ name: 'valueConfigDetail', query: { valueConfigId: scope.row.id } }">
                            <el-button type="primary" size="mini">修改</el-button>
                        </router-link>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="content-data" v-else>
            没有查询到数据
        </div>
        <vue-pager v-bind:datafile="fillData" url="/valueConfig/pageValueConfig" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
    </div>
</template>
<script>
export default {
    data() {
        return {
            valueConfigs: [],
            query: {},
        }
    },
    methods: {
        fillData(_response) {
            var _this = this;
            _this.valueConfigs = _response.items;
        },
        submitQuery(_num) {
            var _this = this;
            _this.valueConfigs = [];
            _this.$refs.pager.gotoPage(_num);
        },
        deleteValueConfig: function(_valueConfigId) {
            var _this = this;
            _this.$confirm('是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.$common.my_ajax({
                    url: '/valueConfig/deleteValueConfig',
                    data: {
                        valueConfigId: _valueConfigId
                    },
                    success: function(response) {
                        _this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 1000,
                            onClose: function() {
                                _this.submitQuery();
                            }
                        });
                    }
                });
            }).catch(() => {
                console.log('取消删除');
            });
        }
    }
}
</script>